/********************************************************************************
 * @author       Tech.us
 * @module       CustomersModule
 * @name         CustomerForm
 * @description  Form component for creating and managing customer details
 * @copyright    Tech.us
 * @Createdon    Mar 2025
 * @since        1.0
 *********************************************************************************/

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'
import Select from 'react-select';
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from "react-redux";
// import FormDirtyCheck from '../../../genriccomponents/FormDirtyCheck';
import Loader from '../../genriccomponents/loaders/RedLoader';
import CONFIG from '../../config/config';
import { GetContry, GetState, CreateCustomer, ListCustomers } from '../../services/techus-services.js'
import TinyLoader from '../../genriccomponents/loaders/TinyWhiteLoader.js'
import '../AuthModule/login.css'
import { showToast } from '../../genriccomponents/techus-ToastNotification.js';
import { capitalFcase } from '../../Helper/helper.js';

function CustomerForm(props) {
  const { page, setShowAddCustomer, setCustomerId } = props
  const dispatch = useDispatch()

  const history = useNavigate();
  const search = useLocation().search;
  const user_id = new URLSearchParams(search).get("user_id");
  const [isLoding, setIsLoading] = useState(false)
  const [mobileNumber, setMobileNumber] = useState('1');
  const [status, setStatus] = useState(0);
  const [stsValue, setStsValue] = useState(() => { return 0 })
  const [formError, setFormError] = useState({});
  const [name, setName] = useState(null)
  const [loader, setLoader] = useState(false)
  const [focused, setFocused] = useState(false)
  const [CountryOption, setCountryOption] = useState([])
  const [StateOption, setStateOption] = useState([])
  const [CountryValue, setCountryValue] = useState('231')
  const [StateValue, setStateValue] = useState(null)
  const [CityValue, setCityValue] = useState(null)
  const [StateFocused, setStateFocused] = useState(false)
  // country state city

  let errors = {};

  const ref_customer_name = useRef();
  const ref_contact_name = useRef();
  const ref_customer_id = useRef();
  const ref_phone_number = useRef();
  const ref_address_1 = useRef();
  const ref_address_2 = useRef();
  const ref_country = useRef();
  const ref_tier = useRef();
  // console.timeLog(:)
  const ref_state = useRef();
  const ref_city = useRef();
  const ref_contact_email = useRef();
  const ref_zip = useRef();

  const [formSubmitted, setFormSubmitted] = useState(false);

  // crop states

  const [fileName, setFileName] = useState(null); //contanins the file name


  const [tierValue, setTierValue] = useState(false)

  const Datas = {
    customer_name: "",
    customer_id: "",
    address_1: "",
    address_2: "",
    tier_type: '',
    country: CountryValue,
    state: StateValue,
    city: "",
    zip: "",
    contact_name: "",
    contact_email: "",
    phone_number: ''
  }

  const [formData, setFormData] = useState(Datas);
  const [initData, setInitData] = useState({ ...formData })

  const Getcountrys = async () => {
    const response = await GetContry();
    if (response.valid) {
      setCountryOption(response.data)
    }
  }
  const GetStates = async (data) => {
    const response = await GetState(data);
    if (response.valid) {
      setStateOption(response.data)
    }
  }

  useEffect(() => {
    Getcountrys();
    GetStates({ country_id: '231' });
  }, [])

  const handleFormChange = (e) => {
    var value = e.target.value;
    if (e.target.name == 'contact_email') {
      setFormData({
        ...formData,
        [e.target.name]: value.toString().trim().replace(/\s/g, '')
      })
    } else if (e.target.name == 'customer_id') {
      const processedValue = value.trim().replace(/\s/g, '')

      setFormData({
        ...formData,
        [e.target.name]: processedValue
      })
    } else {
      setFormData({
        ...formData,
        [e.target.name]: value
      })
    }
    handleUiError(e.target.name)
  }



  // Start form realtime red border validation
  useEffect(() => {
    if (formSubmitted) {
      handleUiError()
      setFormSubmitted(false)
    }
  }, [formSubmitted]);



  const handlePhoneNumberChange = (value) => {
    setMobileNumber(value);
    setFormData({
      ...formData,
      phone_number: value
    })
  };


  // apply red border to invalid inputs 
  const handleUiError = (e, select_value = null) => {
    const name = e;
    const error_form = {};

    if (formSubmitted) {
      if (formError.customer_name) ref_customer_name.current.classList.add('form-control-error');
      if (formError.customer_id) ref_customer_id.current.classList.add('form-control-error');
      // if (formError.customer_id) ref_contact_name.current.classList.add('form-control-error');

      // if (formError.phone_number) phone_number.current.classList.add('form-control-error');
      // if (formError.contact_email) ref_contact_email.current.classList.add('form-control-error');
      if (formError.address_1) ref_address_1.current.classList.add('form-control-error');
      if (formError.address_2) ref_address_2.current.classList.add('form-control-error');
      // if (formError.) ref_designation.current.classList.add('form-control-error');
      // if (formError.phone_number) {
      //   ref_phone_number.current.numberInputRef.classList.add('form-control-error');
      // }
      if (formError.tier_type) {
        ref_tier.current.controlRef.offsetParent.classList.add('react-select-form-control-error');
      }
      if (formError.state) {
        ref_state.current.controlRef.offsetParent.classList.add('react-select-form-control-error');
      }
      if (formError.city) {
        ref_city.current.classList.add('form-control-error')
      }
      if (formError.zip) ref_zip.current.classList.add('form-control-error');
    }

    const setError = (key, value) => {
      setFormError(error => {
        const { [key]: _, ...rest } = error;
        return value ? { ...error, [key]: value } : rest;
      });

    };

    if (name === "customer_name") {
      const input = ref_customer_name.current;
      if (input.value.trim().length === 0) {
        input.classList.add('form-control-error');
        setError('customer_name', "Customer Name is required");
      } else if (input.value.trim().length < CONFIG.MINCHAR) {
        input.classList.add('form-control-error');
        setError('customer_name', `Customer Name must contain a minimum of ${CONFIG.MINCHAR} characters.`);
      } else if (input.value.trim().length > CONFIG.MAXCHAR) {
        input.classList.add('form-control-error');
        setError('customer_name', `Customer Name must contain a maximum of ${CONFIG.MAXCHAR} characters.`);
      }
      else {
        input.classList.remove('form-control-error');
        setError('customer_name', null);
      }
      return;
    }

    if (name === "customer_id") {
      const input = ref_customer_id.current;
      if (input.value.trim().length === 0) {
        input.classList.add('form-control-error');
        setError('customer_id', "Customer ID is required");
      } else if (input.value.trim().length > 26) {
        input.classList.add('form-control-error');
        setError('customer_id', `Customer ID must contain less than 25 characters`);
      } else {
        input.classList.remove('form-control-error');
        setError('customer_id', null);
      }
      return;
    }

    if (name == 'tier_type') {
      // console.log("value i am here")
      let select_state;
      if (select_value == null) {
        select_state = tierValue;
      } else {
        select_state = select_value
      }

      if (select_state === '' || select_state === undefined || select_state === null) {
        ref_tier.current.controlRef.offsetParent.classList.add('react-select-form-control-error');

        setError('tier_type', "Tier type is required");
      }
      else {
        ref_tier.current.controlRef.offsetParent.classList.remove('react-select-form-control-error');
        setError('tier_type', false);
      }
      return;
    }


    if (name === "address_1") {
      const input = ref_address_1.current;
      if (!input.value.trim()) {
        input.classList.add('form-control-error');
        setError('address_1', "Address is required");
      } else if (input.value.trim().length > 257) {
        input.classList.add('form-control-error');
        setError('address_1', `Address must contain less than 256 characters`);
      } else {
        input.classList.remove('form-control-error');
        setError('address_1', null);
      }
      return;
    }
    if (name === "address_2") {
      const input = ref_address_2.current;
      if (input.value.trim().length > 257) {
        input.classList.add('form-control-error');
        setError('address_2', `Address must contain less than 256 characters`);
      } else {
        input.classList.remove('form-control-error');
        setError('address_2', null);
      }
      return;
    }

    // for select state
    if (name == 'state') {
      let select_state;
      if (select_value == null) {
        select_state = StateValue;
      } else {
        select_state = select_value
      }

      if (select_state === '' || select_state === undefined || select_state === null) {
        ref_state.current.controlRef.offsetParent.classList.add('react-select-form-control-error');

        setError('state', "State is required");
      }
      else {
        ref_state.current.controlRef.offsetParent.classList.remove('react-select-form-control-error');
        setError('state', false);
      }

      return;
    }



    // for select city
    if (name == 'city') {
      const input = ref_city.current;
      if (!input.value.trim()) {
        input.classList.add('form-control-error');
        setError('city', "City is required");
      } else if (input.value.trim().length > CONFIG.MAXCHAR) {
        input.classList.add('form-control-error');
        setError('city', `City must contain less than ${CONFIG.MAXCHAR} characters`);
      } else {
        input.classList.remove('form-control-error');
        setError('city', null);
      }
      return;

    }
    if (name === "zip") {
      const input = ref_zip.current;
      if (!input.value.trim()) {
        input.classList.add('form-control-error');
        setError('zip', "ZIP code is required");
      } else {
        input.classList.remove('form-control-error');
        setError('zip', null);
      }
      return;
    }

  };

  const validateForm = (formData, isSubmitting = false) => {
    const errors = {};

    const validateField = (fieldName, value, validators) => {
      validators.forEach(validator => {
        const error = validator(value);
        if (error) {
          if (!errors[fieldName]) {
            errors[fieldName] = error;
          }
        }
      });
    };

    // Define validators for each field
    const fieldValidators = {
      customer_name: [
        (value) => !value.trim() && "Customer Name is required",
        (value) => value.trim().length < CONFIG.MINCHAR && `Customer Name must contain a minimum of ${CONFIG.MINCHAR} characters`,
        (value) => value.trim().length > CONFIG.MAXCHAR && `Customer Name must contain less than 25 characters`
      ],
      customer_id: [
        (value) => !value.trim() && "Customer ID is required",
        (value) => value.trim().length > 26 && `Customer ID must contain less than 25 characters`
      ],
     
      tier_type: [
        (value) => !value && "Tier Type is required"
      ],
      address_1: [
        (value) => !value.trim() && "Address is required",
        (value) => value.trim().length > 257 && `Address must contain less than 256 characters`
      ],
      address_2: [

        (value) => value.trim().length > 257 && `Address must contain less than 256 characters`
      ],
      state: [
        (value) => !value && "State is required"
      ],
      city: [
        (value) => !value.trim() && "City is required",
        (value) => value.trim().length > 25 && `City must contain less than 25 characters`
      ],
      zip: [
        (value) => !value.trim() && "ZIP code is required"
      ],
      designation: [
        (value) => !value.trim() && "Designation is required",
        (value) => value.trim().length > 25 && `Designation must contain less than 25 characters`
      ]
      // Add more fields as needed
    };

    // Validate each field based on its validators
    Object.keys(formData).forEach(fieldName => {
      if (fieldValidators[fieldName]) {
        validateField(fieldName, formData[fieldName], fieldValidators[fieldName]);
      }
    });

    // Additional form-wide validations for form submission
    if (isSubmitting) {
      const additionalErrors = form_validation(formData);
      Object.assign(errors, additionalErrors);
    }

    return errors;
  };


  // edit organization data fetch here
  useEffect(() => {

    const handleGetUserList = async () => {
      setLoader(true)
      const formData = { userId: user_id }
      const response = await ListCustomers(formData)
      if (response.valid) {
        const profile = response.user[0];
        setName(profile.customer_name)

        setMobileNumber(profile.phone_number)

        const profileObj = {
          customer_name: profile.customer_name,
          customer_id: profile.customer_id,
          address_1: profile.address_1,
          address_2: profile.address_2,
          country: profile.country,
          tier_type: profile.tier_type,
          state: profile.state,
          city: profile.city,
          zip: profile.zip_code,
          contact_name: profile.contact_name,
          contact_email: profile.contact_email,
          phone_number: profile.phone_number
        }

        GetStates({ country_id: profile.country })
        setStateValue(profile.state)
        setCountryValue(profile.country)
        setStatus(profile.status);
        setTierValue(profile.tier_type)
        setStsValue(profile.status === 1 ? 1 : 0)
        setFormData({ ...profileObj })
        setInitData({ ...profileObj })
        setFileName(profile.image_name)
        setLoader(false)
      } else {
        setLoader(false)
        showToast('error', response.message)
      }

    }

    if (user_id !== undefined && user_id !== null && user_id !== '') {
      handleGetUserList()
    }
  }, []);

  const handleUpdate = async () => {
    if (Object.keys(formError).length === 0) {
      setIsLoading(true)
      let data = {
        ...formData,
        image_name: fileName,
        userId: user_id,
        status: stsValue
      }

      const response = await CreateCustomer(data)
      if (response.valid == true) {
        showToast('success', response.message, 'top-center')
        if (page == 'add_project') {
          setCustomer(response.user_id)
        } else {
          setTimeout(() => {
            history('/customers')
          }, 2000);
        }
      } else {
        showToast('error', response.message, 'top-center')
      }
      setIsLoading(false)
    }
  }

  const handleSubmit = async () => {

    let data = {
      ...formData,
    }

    let error_data = validateForm(data);
    if (Object.keys(error_data).length > 0) { setFormError(error_data); setFormSubmitted(true); setLoader(false); return false; }
    page == 'add_project' ? setIsLoading(true) : setLoader(true)

    const response = await CreateCustomer(data)
    if (response.valid) {
      page == 'add_project' ? setIsLoading(true) : setLoader(true)
      showToast('success', response.message, 'top-center');
      setFormData(Datas)
      if (page !== 'add_project') {
        setTimeout(() => {
          history('/customers')
        }, 2000);
      } else {
        setCustomerId(response.user_id)
        setShowAddCustomer(false)
      }

    } else {

      page == 'add_project' ? setIsLoading(true) : setLoader(false)
      showToast('error', response.message, 'top-center');
    }
  }



  const handleCountry = (event) => {
    var value = event.value;
    setCountryValue(value)
    setFormData({
      ...formData,
      country: JSON.stringify(value),
      state: null,
    })
    GetStates({ country_id: value })

    setStateValue(null)
  };

  const handleState = (event) => {
    var value = event.value;
    setStateValue(value)
    setFormData({
      ...formData,
      state: JSON.stringify(value),
      city: ''
    })
    // GetCitys({ state_id: value })
    setCityValue(null)
  };
  const handleCity = (event) => {
    var value = event.value;
    setCityValue(value)
    setFormData({
      ...formData,
      city: JSON.stringify(value)
    })
  };


  //handle status Change
  const handleChangeStatus = () => {
    setStatus(status === 1 ? 0 : 1)
    setFormData({
      ...formData,
      status: status === 1 ? 0 : 1
    })
    setStsValue(status === 1 ? 0 : 1)
    
  };


  const handleTier = (event) => {
    var value = event.value;
    setTierValue(value)
    setFormData({
      ...formData,
      tier_type: value,
    })
  };


  const CustomTierOption = [{
    value: '1',
    label: 'Tier A'
  },
  {
    value: '2',
    label: 'Tier B'
  },
  {
    value: '3',
    label: 'Tier C'
  },];

  return (
    <>
      {loader ? <Loader /> :
        <>
          {page == 'add_customer' && <div className='d-flex mt-4'>
            <div className='back-button cursor-pointer' onClick={() => history('/customers')}>
              <i className='icon-left'></i>
            </div>
            <div className='back-btn-content'>
              <p> {user_id ? 'Customers - ' + name + ' - Edit' : 'Customers - Add Customer'}</p>
              <p className='text-20 text-bold-700'> {user_id ? 'Edit Customer' : 'Add New Customer'}</p>
            </div>
          </div>}
          {/* <FormDirtyCheck formData={formData} initialFormData={initData} formDirtyCheck={formDirtyCheck} setFormDirtyCheck={setFormDirtyCheck} /> */}
          <div className={` ${page === 'add_customer' ? 'admin-wrapper animate__animated animate__fadeIn pt-4' : ''}`}>
            <div className='row m-0 p-0 mx-4'>


              <div className='col-12 col-md-12 col-lg-12  p-0' >
                <div className='row'>

                  <div className='col-12 col-md-6 col-lg-4  pe-5'>
                    <label className=" mf-label" >Customer Name <span className='red-color'>*</span></label>

                    <div className="form-group relative  mb-4 ">

                      <input ref={ref_customer_name}
                        onBlur={() => handleUiError(ref_customer_name.current.name)}
                        className="form-control" name="customer_name" autoComplete="off" type="text" value={capitalFcase(formData.customer_name)} onChange={handleFormChange} />

                      {formError.customer_name && (
                        <span className="login-error"> {formError.customer_name} </span>
                      )}
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4  pe-5'>
                    <label className="mf-label" >Customer ID <span className='red-color'>*</span></label>

                    <div className="form-group label relative mb-4">

                      <input ref={ref_customer_id} onBlur={() => handleUiError(ref_customer_id.current.name)} className="form-control" name="customer_id" autoComplete="off" type="text" value={formData.customer_id} onChange={handleFormChange} />

                      {formError.customer_id && (
                        <span className="login-error"> {formError.customer_id} </span>
                      )}


                    </div>
                  </div>

                  <div className='col-12 col-md-4 col-lg-3  pe-5'>
                    <div className="form-group label relative mb-4  ">
                      <label className=" mf-label" >Select Tier <span className='red-color'>*</span></label>
                      <Select className='country-select react-select-container '
                        name={"tier_type"}
                        ref={ref_tier}
                        value={tierValue !== null ? CustomTierOption.find(op => { return op.value == tierValue }) : null}

                        onChange={(e) => {
                          handleTier(e)
                          handleUiError(ref_tier.current.props.name, e.value)
                        }
                        }
                        // onFocus={() => setStructureFocused(true)}
                        onBlur={
                          (e) => {
                            // setStructureFocused(false)
                            handleUiError(ref_tier.current.props.name)
                          }
                        }
                        placeholder={'Select Tier'}
                        classNamePrefix="react-select"
                        options={CustomTierOption}
                      // defaultValue={{ value: 2, label: "User" }}
                      />
                      {/* <input onBlur={() => handleUiError(password.current.name)} ref={password} placeholder="********" className="form-control cutom-password" name="password" autoComplete="new-password" type="password" value={formData.password} onChange={handleFormChange} /> */}
                      {formError.tier_type && (
                        <span className="login-error"> {formError.tier_type} </span>
                      )}
                    </div>
                  </div>



                </div>
                <div className='row'>
                  <div className='col-12 col-md-4 col-lg-4 pe-5 '>
                    <label className=" mf-label" >Address 1 <span className='red-color'>*</span></label>
                    <div className="label relative mb-4">
                      <input ref={ref_address_1} onBlur={() => handleUiError(ref_address_1.current.name)} className="form-control" name="address_1" autoComplete="off" type="text" value={capitalFcase(formData.address_1)} onChange={handleFormChange} />

                      {formError.address_1 && (
                        <span className="login-error"> {formError.address_1} </span>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-4 col-lg-4 pe-5'>
                    <label className="mf-label" >Address 2</label>

                    <div className="label relative mb-4">
                      <input onBlur={() => handleUiError(ref_address_2.current.name)} ref={ref_address_2} className="form-control " name="address_2" autoComplete="off" type="text" value={capitalFcase(formData.address_2)} onChange={handleFormChange} />
                      {formError.address_2 && (
                        <span className="login-error"> {formError.address_2} </span>
                      )}
                    </div>
                  </div>



                </div>
                {/* password Enter start */}

                <div className='row'>

                  <div className='col-12 col-md-4 col-lg-4  pe-5'>
                    <div className="form-group label relative mb-4 ">
                      <label className=" mf-label" >Country <span className='red-color'>*</span></label>
                      <Select className='country-select react-select-container '
                        name={"country"}
                        ref={ref_country}
                        value={CountryOption.find(op => { return op.value == CountryValue })}
                        onChange={handleCountry}
                        // onFocus={() => setFocused(true)}
                        placeholder={focused ? "Search" : 'Select Country'}
                        classNamePrefix="react-select"
                        options={CountryOption}
                        defaultValue={{ value: 231, label: "United States" }}
                      />
                      {/* <input onBlur={() => handleUiError(password.current.name)} ref={password} placeholder="********" className="form-control cutom-password" name="password" autoComplete="new-password" type="password" value={formData.password} onChange={handleFormChange} /> */}
                      {/* {formError.password && (
             <span className="login-error"> {formError.password} </span>
           )} */}
                    </div>

                  </div>
                  <div className='col-12 col-md-4 col-lg-4  pe-5'>
                    <div className="form-group label relative mb-4  ">
                      <label className=" mf-label" >State <span className='red-color'>*</span></label>
                      <Select className='country-select react-select-container '
                        name={"state"}
                        ref={ref_state}
                        value={StateValue !== null ? StateOption.find(op => { return op.value == StateValue }) : null}

                        onChange={(e) => {
                          handleState(e)
                          handleUiError(ref_state.current.props.name, e.value)
                        }
                        }
                        onFocus={() => setFocused(true)}
                        onBlur={
                          (e) => {
                            setStateFocused(false)
                            handleUiError(ref_state.current.props.name)
                          }
                        }
                        placeholder={StateFocused ? "Search" : 'Select State'}
                        classNamePrefix="react-select"
                        options={StateOption}
                      // defaultValue={{ value: 2, label: "User" }}
                      />
                      {/* <input onBlur={() => handleUiError(password.current.name)} ref={password} placeholder="********" className="form-control cutom-password" name="password" autoComplete="new-password" type="password" value={formData.password} onChange={handleFormChange} /> */}
                      {formError.state && (
                        <span className="login-error"> {formError.state} </span>
                      )}
                    </div>

                  </div>
                </div>

              </div>

              <div className='col-12 col-md-12 col-lg-12  p-0'>
                <div className='row '>
                  <div className='col-12 col-md-6 col-lg-4  pe-5'>
                    <div className="form-group label relative mb-4 ">
                      <label className=" mf-label" >City <span className='red-color'>*</span></label>
                     
                      <input onBlur={() => handleUiError(ref_city.current.name)} ref={ref_city} className="form-control cutom-password" name="city" autoComplete="new-password" type="text" value={capitalFcase(formData.city)} onChange={handleFormChange} />
                      {formError.city && (
                        <span className="login-error"> {formError.city} </span>
                      )}
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4 pe-5'>
                    <label className=" mf-label" >ZIP code <span className='red-color'>*</span></label>
                    <div className="label relative mb-4">
                      <input
                        pattern="[0-9]*"
                        maxLength={6}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        ref={ref_zip} onBlur={() => handleUiError(ref_zip.current.name)} className="form-control" name="zip" autoComplete="off" type="text" value={formData.zip} onChange={handleFormChange} />
                      {formError.zip && (
                        <span className="login-error"> {formError.zip} </span>
                      )}
                    </div>
                  </div>

                </div>
              </div>
              <div className='col-12 col-md-12 col-lg-12  p-0'>
                <div className='row '>
                  <div className='col-12 col-md-4 col-lg-4  pe-5'>
                    <label className=" mf-label" >Contact Name </label>

                    <div className="form-group relative mb-4 ">

                      <input ref={ref_contact_name}
                        onBlur={() => handleUiError(ref_contact_name.current.name)}
                        className="form-control" name="contact_name" autoComplete="off" type="text" value={capitalFcase(formData.contact_name)} onChange={handleFormChange} />

                      {formError.contact_name && (
                        <span className="login-error"> {formError.contact_name} </span>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-4 col-lg-4  pe-5'>
                    <label className=" mf-label" >Contact Email </label>

                    <div className="form-group label relative mb-4">
                      <input onBlur={() => handleUiError(ref_contact_email.current.name)} ref={ref_contact_email} className="cutom-password form-control" name="contact_email" autoComplete="new-email" type="text" value={formData.contact_email} onChange={handleFormChange} />

                      {formError.contact_email && (
                        <span className="login-error"> {formError.contact_email} </span>
                      )}
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4  pe-5'>

                    <div className="form-group label relative mb-4">
                      <label className=" mf-label" >Phone Number </label>
                      {/* <input onBlur={() => handleUiError(phone_number.current.name)} ref={phone_number} className="form-control" name="phone_number" autoComplete="off" type="text" value={formData.phone_number} onChange={handleFormChange} /> */}
                      <PhoneInput
                        onBlur={() => handleUiError(ref_phone_number.current.props.name)}
                        ref={ref_phone_number}
                        name={"phone_number"}
                        country={'us'}
                        countryCodeEditable={false}
                        value={mobileNumber}
                        onChange={(value) => {
                          handlePhoneNumberChange(value)
                          handleUiError(ref_phone_number.current.props.name)
                        }}
                      />
                      {formError.phone_number && (
                        <span className="login-error"> {formError.phone_number} </span>
                      )}
                    </div>
                  </div>
                </div>


                {user_id ?

                  (<div className='col-12 col-md-12 col-lg-12  '>
                    <div className=" mt-3 profile-status">
                      <div className=" spd-active-container  form-control">
                        <div className="status-row d-flex align-items-center justify-content-between m-1 ">
                          <p className="m-0 text-bold-700">Status</p>
                          <span className="m-0">
                            {status == 1 ? <span className="positive-green-color text-18 "><i className="icon-circle-fill text-18 me-2 "></i>Active</span> : <span className="red-color text-18 "> Inactive</span>}
                          </span>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={status === 1}
                              onChange={(e) => handleChangeStatus(e)}
                            />
                            <i className="sliders"></i>
                          </label>

                        </div>


                      </div>
                      <p className="mt-1">
                        Toggle status to make {status == 1 ? "Inactive" : "Active"}
                      </p>
                    </div></div>) : null
                }
              </div>
              <div className='d-flex container-fluid mt-3 p-0 justify-content-between '>

                <div className='d-flex container-fluid align-items-end  px-4'>

                  {page !== 'add_customer' &&
                    <>
                      {isLoding ? <button className="mf4-start-btn d-flex-center ado-dangers-btn btn-hover-blue ms-3" ><TinyLoader /></button> :
                        <button className="mf4-start-btn d-flex-center width-149 ado-dangers-btn btn-hover-blue ms-3" onClick={handleSubmit}>Add Customer</button>}
                    </>
                  }
                </div>

              </div>

            </div>
          </div>

          <div className='d-flex justify-content-between mt-3'>

            {page == 'add_customer' &&
              <>
                <div onClick={() => history('/customers')} className='back-project-btn align-center cursor-pointer' >
                  <span className='px-4'>Cancel </span>
                </div>
                {!isLoding ?
                  <button className="mf4-start-btn d-flex-center ado-dangers-btn  btn-hover-blue " onClick={user_id ? handleUpdate : handleSubmit}>{user_id ? 'Update' : 'Add Customer'} </button> :
                  <>{isLoding && page !== 'profile' && page !== 'add_project' && <button className="mf4-start-btn d-flex-center ado-dangers-btn  btn-hover-blue "><TinyLoader /></button>}</>
                }
              </>}
          </div>
        </>
      }
    </>
  )
}

export default CustomerForm 